// extracted by mini-css-extract-plugin
module.exports = {"hidden":"emptyMyChat_hidden__xFsqq","textEmphasis":"emptyMyChat_textEmphasis__UkmTE","emptyArea":"emptyMyChat_emptyArea__lgCEO"};